// import React from 'react'

// const SearchOffIcon = ({ color, width, className }) => {
//     return <svg className={className} width={width} height={width} viewBox={`0 0 ${width} ${width}`} fill={color} xmlns="http://www.w3.org/2000/svg">
//         <rect x="7.54539" y="9.51527" width="2.14292" height="12.2097" rx="1.07146" transform="rotate(-45 7.54539 9.51527)" fill="#0060F9" />
//         <circle cx="7" cy="7" r="7" fill="#0060F9" />
//         <circle cx="7" cy="7" r="5" fill="#0060F9" />
//         <rect x="4" y="5.04044" width="1.4714" height="7.35702" rx="0.735702" transform="rotate(-45 4 5.04044)" fill="white" />
//         <rect x="9.2022" y="4" width="1.4714" height="7.35702" rx="0.735702" transform="rotate(45 9.2022 4)" fill="white" />
//     </svg>






// }

// export default SearchOffIcon

import React from 'react'

const SearchOffIcon = ({ color, width, className }) => {
    return <svg className={className} width="24" viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
        <rect x="10.6974" y="13.7382" width="4.30033" height="14.5124" rx="2.15016" transform="rotate(-45 10.6974 13.7382)" fill={color} />
        <ellipse cx="8.3202" cy="8.3202" rx="8.3202" ry="8.3202" fill={color} />
        <ellipse cx="8.3202" cy="8.3202" rx="5.943" ry="5.943" fill={color} />
        <rect x="4.7544" y="5.99107" width="1.74891" height="8.74455" rx="0.874455" transform="rotate(-45 4.7544 5.99107)" fill="white" />
        <rect x="10.9377" y="4.7544" width="1.74891" height="8.74455" rx="0.874455" transform="rotate(45 10.9377 4.7544)" fill="white" />
    </svg>
}

export default SearchOffIcon